import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import { GET_VEHICLE } from 'Util/queries';
const { Option } = Select;

function VehiclesDropDown({ onChange, form, value, ...rest }) {

    const { data, loading } = useQuery(GET_VEHICLE, {
        variables: {
            where: {
                deleted_at: { _is_null: true }
            }
        },
    });

    const list = data?.vehicles ?? [];

    const handleChange = (v) => {
        const selected = list.find(item => item.id === v);
        if (form && selected) {
            form.setFieldsValue({
                vehicle_id: selected.id,
                vehicle_number: selected.number,
            });
        }
        if (onChange) onChange(v);
    };

    return (
        <Select
            {...rest}
            value={value}
            loading={loading}
            placeholder="Select a vehicle"
            onChange={handleChange}
        >
            {list.map(v => <Option value={v.id} key={`vehicles-dd-opt${v.id}`}>{v.number}</Option>)}
        </Select>
    )
}

export default VehiclesDropDown
